module.exports = __webpack_public_path__ + "img/download_13.e72ad600.png";